import { combineEpics } from 'redux-observable'
import * as starter from './starter'
import * as stateControl from './stateControl'

export const rootEpic = combineEpics(
  starter.loadingEpic,
  stateControl.sendEmailEpic
)
